/**
 * Trie Node.
 */
var InvertedIndexNode = /** @class */ (function () {
    function InvertedIndexNode(charCode) {
        this.charCode = charCode;
        this.next = null;
        this.firstChild = null;
        this.firstPosting = null;
    }
    return InvertedIndexNode;
}());
export { InvertedIndexNode };
/**
 * Create trie nodes for the `term` starting from the `start` character.
 */
function createNodes(parent, term, start) {
    for (; start < term.length; start++) {
        var newNode = new InvertedIndexNode(term.charCodeAt(start));
        if (parent.firstChild === null) {
            parent.firstChild = newNode;
        }
        else {
            newNode.next = parent.firstChild;
            parent.firstChild = newNode;
        }
        parent = newNode;
    }
    return parent;
}
/**
 * Find trie child node that matches `charCode`.
 */
function findChild(node, charCode) {
    var child = node.firstChild;
    while (child !== null) {
        if (child.charCode === charCode) {
            return child;
        }
        child = child.next;
    }
    return undefined;
}
/**
 * Inverted Index implemented with a trie data structure.
 */
var InvertedIndex = /** @class */ (function () {
    function InvertedIndex() {
        this.root = new InvertedIndexNode(0);
    }
    /**
     * Get trie node that matches the `term`.
     */
    InvertedIndex.prototype.get = function (term) {
        var node = this.root;
        for (var i = 0; i < term.length; i++) {
            node = findChild(node, term.charCodeAt(i));
            if (node === undefined) {
                return null;
            }
        }
        return node;
    };
    InvertedIndex.prototype.add = function (term, docDetails, termFrequency) {
        var node = this.root;
        for (var i = 0; i < term.length; i++) {
            if (node.firstChild === null) {
                node = createNodes(node, term, i);
                break;
            }
            var nextNode = findChild(node, term.charCodeAt(i));
            if (nextNode === undefined) {
                node = createNodes(node, term, i);
                break;
            }
            node = nextNode;
        }
        var pointer = {
            next: null,
            details: docDetails,
            termFrequency: termFrequency,
        };
        if (node.firstPosting === null) {
            node.firstPosting = pointer;
        }
        else {
            pointer.next = node.firstPosting;
            node.firstPosting = pointer;
        }
    };
    /**
     * Expand term with all indexed terms.
     */
    InvertedIndex.prototype.expandTerm = function (term) {
        var node = this.get(term);
        var results = [];
        if (node !== null) {
            _expandTerm(node, results, term);
        }
        return results;
    };
    /**
     * Remove outdated/removed documents from the index.
     */
    InvertedIndex.prototype.vacuum = function () {
        _vacuum(this.root);
    };
    return InvertedIndex;
}());
export { InvertedIndex };
function _expandTerm(node, results, term) {
    if (node.firstPosting !== null && node.firstPosting !== null) {
        results.push(term);
    }
    var child = node.firstChild;
    while (child !== null) {
        _expandTerm(child, results, term + String.fromCharCode(child.charCode));
        child = child.next;
    }
}
function _vacuum(node) {
    var prevPointer = null;
    var pointer = node.firstPosting;
    while (pointer !== null) {
        if (pointer.details.removed) {
            if (prevPointer === null) {
                node.firstPosting = pointer.next;
            }
            else {
                prevPointer.next = pointer.next;
            }
        }
        else {
            prevPointer = pointer;
        }
        pointer = pointer.next;
    }
    var child = node.firstChild;
    while (child !== null) {
        _vacuum(child);
        child = child.next;
    }
}
//# sourceMappingURL=inverted_index.js.map